import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class CodeListMainItemsDTO {
    @ApiProperty()
    codeListMainItemId: number;
    @ApiProperty()
    codeListMainId: number;
    @ApiProperty()
    code: string;
    @ApiProperty()
    soItemId:number;
    @ApiProperty()
    tracebilityCodeId: number;
    @ApiProperty()
    cartons: number;
    @ApiProperty()
    productionDate: Date;
    @ApiProperty()
    bestBeforeDate: Date;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()
    versionFlag: number;
    @ApiProperty()
    unitId:number;
   

  
}